export enum HeartbeatChartPeriod {
  Week = 'week',
  Month = 'month',
  TrailingWeek = 'trailingWeek',
  TrailingMonth = 'trailingMonth',
  Custom = 'custom',
}
